import React, { useEffect, useState } from "react";
import Resume from "./nimbusResume.view";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  OUT_POINT_NIMBUS1,
  OUT_POINT_NIMBUS2,
  STANDALONE_PROCESS_NIMBUS,
} from "../../../../constants";
import { useReadBigBag } from "../hook/useReadBigBag";
import { useStandAloneProcess } from "../hook/useStandAloneProcess";

const NimbusResumeContainer = (props) => {
  const processType = STANDALONE_PROCESS_NIMBUS.code;
  const outPoints = [OUT_POINT_NIMBUS1, OUT_POINT_NIMBUS2];
  // const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [type, setType] = useState(null);
  const [showPoint, setShowPoint] = useState(false);
  const [showResume, setShowResume] = useState(true);
  const [action, setAction] = useState("");
  const { readBigBag } = useReadBigBag(processType);
  const {
    data,
    createStandAloneProcess,
    registerBB,
    handlerRemove,
    handlerFinish,
    handlerDelete,
  } = useStandAloneProcess(processType);

  const handlerReset = () => {
    setShowPoint(false);
    setShowResume(true);
    setType(null);
  };

  const handlerOpenCyclone = () => {
    setType(null);
    setShowPoint(true);
    setShowResume(false);
    setAction("open");
  };

  const handlerRegister = (actionType) => {
    setType(actionType);
    setShowPoint(true);
    setShowResume(false);
    setAction(`register${actionType}`);
  };

  return (
    <>
      {showPoint &&
        readBigBag(
          type,
          action,
          createStandAloneProcess,
          registerBB,
          handlerReset,
          outPoints
        )}
      {showResume && (
        <Resume
          data={data}
          openCyclone={handlerOpenCyclone}
          registerBB={handlerRegister}
          finish={handlerFinish}
          removeItem={handlerRemove}
          onDelete={handlerDelete}
        />
      )}
    </>
  );
};

NimbusResumeContainer.propTypes = {};

export default NimbusResumeContainer;
